export default {
  groupName: 'adpi-category-covid',
  appName: 'Cross Category',
  baseRoute: '/dashboard/adpi-category-covid',
  label: 'AdPi Cross Category Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'AdPi Cross Category Advertising Dashboard'
}
